module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/sample_talk2-f896756e03ea01bbc8b364cc60ead6d6.png";